import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { useIsFirstRun } from '@cian/valuation-utils-component';
import { EOfferType, dealTypeSelectorOptions, offerTypeSelectorOptions, objectTypeCommercialSelectorOptions, objectTypeFlatSelectorOptions, objectTypeSelectorOptionsCombined, objectTypeSuburbanSelectorOptions, objectToOfferMap } from '../../../constants';
import { getInitialFormState } from './getInitialFormState';

/** Логика формы фильтров "Подбор риелтора" */
export var useFiltersForm = function useFiltersForm(options) {
  var initialState = options.initialState,
      onChange = options.onChange;
  var isFirstRun = useIsFirstRun();

  var _React$useState = React.useState(Boolean(initialState === null || initialState === void 0 ? void 0 : initialState.objectType)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isConvertObjectToOffer = _React$useState2[0],
      setConvertObjectToOffer = _React$useState2[1];

  var _React$useState3 = React.useState(getInitialFormState({
    initialState: initialState
  })),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      state = _React$useState4[0],
      setState = _React$useState4[1];
  /** Здесь ссылка на стейт присваивается внешней рефке, чтоб извне был доступ к стейту */


  if (options.stateRef) {
    options.stateRef.current = state;
  }

  useOnStateChange(state, onChange);
  /**
   * Когда юзер выбирает тип объекта из полного списка (т.е тип недвижимости еще не выбран)
   * По выбранному типу объекта будет вычислен и установлен тип недвижимости
   * */

  React.useEffect(function () {
    if (!isFirstRun && !state.offerType && state.objectType) {
      var offerTypeFromObjectType = objectToOfferMap[state.objectType];
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          offerType: offerTypeFromObjectType
        });
      });
      setConvertObjectToOffer(true);
    }
    /** Вызываем только когда меняется тип оффера */
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [state.objectType]);
  /**
   * Если юзер выбирает другой Тип недвижимости, то "Объект" нужно сбросить, т.к они разные для разной недвиги
   * Не будет вызвано, когда тип недвижимости установился программно после установки типа оффера
   * */

  React.useEffect(function () {
    if (!isConvertObjectToOffer) {
      if (!isFirstRun) {
        setState(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            objectType: null
          });
        });
      }
    } else {
      setConvertObjectToOffer(false);
    }
    /** Вызываем только когда меняется тип недвижимости */
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [state.offerType]);
  /** Разные Объекты для разных типов недвижимости */

  var objectTypeOptions = React.useMemo(function () {
    if (state.offerType === EOfferType.Flat) {
      return objectTypeFlatSelectorOptions;
    }

    if (state.offerType === EOfferType.Suburban) {
      return objectTypeSuburbanSelectorOptions;
    }

    if (state.offerType === EOfferType.Commercial) {
      return objectTypeCommercialSelectorOptions;
    }

    return objectTypeSelectorOptionsCombined;
  }, [state.offerType]);
  var setDealType = React.useCallback(function (dealType) {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        dealType: dealType
      });
    });
  }, []);
  var setOfferType = React.useCallback(function (offerType) {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        offerType: offerType
      });
    });
  }, []);
  var setObjectType = React.useCallback(function (objectType) {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        objectType: objectType
      });
    });
  }, []);
  return {
    state: state,
    setDealType: setDealType,
    setOfferType: setOfferType,
    setObjectType: setObjectType,
    dealTypeSelectorOptions: dealTypeSelectorOptions,
    offerTypeSelectorOptions: offerTypeSelectorOptions,
    objectTypeOptions: objectTypeOptions
  };
};
/** Хелпер для отслеживания изменений в стейте формы и вызова пользовательского коллбэка */

function useOnStateChange(formState, onChange) {
  var previousProps = React.useRef();
  React.useEffect(function () {
    if (previousProps.current) {
      var keyChanged = Object.keys(_objectSpread(_objectSpread({}, previousProps.current), formState)).find(function (key) {
        return previousProps.current && previousProps.current[key] !== formState[key];
      });

      if (keyChanged) {
        onChange(keyChanged, formState[keyChanged], formState);
      }
    }

    previousProps.current = formState;
  }, [formState, onChange]);
}